export default __webpack_public_path__ + "static/media/coffeepass_demo.c621a50d.gif";